import "antd/es/dropdown/style";
import _Dropdown from "antd/es/dropdown";
import _extends from "@babel/runtime/helpers/esm/extends";
import "antd/es/config-provider/style";
import _ConfigProvider from "antd/es/config-provider";
import React, { useContext } from 'react';
import Footer from '../DropdownFooter';
import './index.less';

var FilterDropdown = function FilterDropdown(props) {
  var children = props.children,
      label = props.label,
      footer = props.footer,
      disabled = props.disabled,
      onVisibleChange = props.onVisibleChange,
      visible = props.visible,
      footerRender = props.footerRender,
      placement = props.placement;

  var _useContext = useContext(_ConfigProvider.ConfigContext),
      getPrefixCls = _useContext.getPrefixCls;

  var prefixCls = getPrefixCls('pro-core-field-dropdown');
  return (
    /*#__PURE__*/
    //@ts-expect-error
    React.createElement(_Dropdown, {
      disabled: disabled,
      placement: placement,
      trigger: ['click'],
      visible: visible,
      onVisibleChange: onVisibleChange,
      overlay: /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-overlay")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-content")
      }, children), footer && /*#__PURE__*/React.createElement(Footer, _extends({
        disabled: disabled,
        footerRender: footerRender
      }, footer)))
    }, /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-label")
    }, label))
  );
};

export default FilterDropdown;